import { createApp } from 'vue'
import App from './App.vue'

// 路由
import router from './router.js';
import qs from 'qs';

//element
import ElementPlus from 'element-plus'
import './css/element/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//本项目样式
import './css/main.css'
import './css/main2.css'
import Message from './common/Common';

//百度地图
import baiduMap  from 'vue3-baidu-map-gl'

//滚动
import vue3SeamlessScroll from "vue3-seamless-scroll";

//Vconsole
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()


const app = createApp(App)
app.config.globalProperties.$qs=qs
app.use(router)
app.use(ElementPlus)
app.use(vue3SeamlessScroll)
app.use(Message)
//app.use(vConsole)
app.use(baiduMap, {
  ak: '2ylMTTzlrMZk4czhIrR5WMmeVi8phbuW',
  plugins: ['TrackAnimation']
} )
app.mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

